import { useTranslation } from "react-i18next";
import ContactSection from "../components/ContactSection";

export default function TechInterview() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-6 text-center space-y-10 bg-white">
      
      <h2 className="text-5xl lg:text-7xl font-black uppercase tracking-tighter">
        {t("tech.title")}
      </h2>

      <p className="text-slate-400 font-medium max-w-2xl mx-auto italic">
        {t("tech.subtitle")}
      </p>
        <button
              onClick={() => window.open("https://tech-interview.com/", "_blank")}
              className="bg-blue-600 text-white px-10 py-4 rounded-2xl font-bold uppercase text-sm tracking-wider shadow-xl hover:bg-blue-700 transition"
            >
              {t("home.hero.button")}
            </button>
      {/* <div className="max-w-4xl mx-auto bg-slate-50 p-2 rounded-[40px] shadow-inner mb-40">
        <img
          src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200"
          className="rounded-[38px] w-full"
        />
      </div> */}

      <ContactSection />

    </section>
  );
}